module.exports = __webpack_public_path__ + "img/team.9bce7ded.svg";